import { ListBase } from 'react-admin';
import { ActivityLogIterator } from './ActivityLogIterator';
import { MemberId } from '@wwf/sdk';
import { ActivityLogContextValue } from './types';

type MemberActivityLogProps = {
    memberId: MemberId;
    pageSize?: number;
    context?: ActivityLogContextValue;
};

export function MemberActivityLog({
    memberId,
    pageSize = 25,
    context = 'all',
}: MemberActivityLogProps) {
    return (
        <ListBase
            resource="activityLog"
            filter={{ authorId: memberId }}
            perPage={pageSize}
            sort={{ field: 'activityDate', order: 'DESC' }}
        >
            <ActivityLogIterator context={context} />
        </ListBase>
    );
}
